import React from "react";
import PropTypes from "prop-types";
import Dialog from "./Dialog";
import { Field, ProgressBar, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    gap: "10px"
  },
  content: {
    minHeight: "auto",
    padding: "0px"
  }
});

export default function ProgressDialog({ message, onConfirm, cancelable, onCancel, ...props }) {
  const styles = useStyles();
  return (
    <Dialog maxWidth={"500px"} classNameContent={styles.content} onCancel={cancelable ? onCancel : null} {...props}>
      <Field validationMessage={message} validationState="none">
        <ProgressBar thickness="large" />
      </Field>
    </Dialog>
  );
}

ProgressDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  cancelable: PropTypes.bool,
  cancelLabel: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};

ProgressDialog.defaultProps = {
  title: "Loading...",
  cancelable: false,
  cancelLabel: "Cancel"
};
